import React from "react"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import shipwreckExt from "../assets/images/shipwreck-ext.jpg"

/**
 * Emits schema.org LodgingBusiness JSON-LD for the site (NAP, geo, price,
 * images, sameAs). Rendered site-wide via Layout so every page carries a
 * consistent business entity for search engines and AI answer engines.
 *
 * Note: intentionally omits Haidaway Cottage imagery/links while that
 * property is hidden, and omits aggregateRating (no fabricated numbers).
 */
const StructuredData = () => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
        }
      }
    }
  `)

  const siteUrl = site.siteMetadata?.siteUrl || ``

  const data = {
    "@context": "https://schema.org",
    "@type": "LodgingBusiness",
    "@id": `${siteUrl}/#lodging`,
    name: "Gold Coast Retreat",
    description:
      "Tofino vacation cabin rentals nestled in a rainforest clearing, a one-minute walk from Chesterman Beach on Vancouver Island's west coast.",
    url: siteUrl,
    telephone: "+1-250-725-3789",
    email: "info@goldcoasttofino.com",
    priceRange: "$225–$350 CAD",
    image: [`${siteUrl}${shipwreckExt}`],
    address: {
      "@type": "PostalAddress",
      streetAddress: "1338 Chesterman Beach Road, Box 3",
      addressLocality: "Tofino",
      addressRegion: "BC",
      postalCode: "V0R 2Z0",
      addressCountry: "CA",
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: 49.1135,
      longitude: -125.8887,
    },
    sameAs: [
      "https://www.tripadvisor.ca/Hotel_Review-g154942-d1473378-Reviews-Gold_Coast_Retreat-Tofino_Clayoquot_Sound_Alberni_Clayoquot_Regional_District_Vancouve.html",
      "https://www.airbnb.ca/rooms/19529407",
    ],
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  )
}

export default StructuredData
